export default __webpack_public_path__ + "static/media/Guita_1.18964644.wav";